"use client"

import {
  GetArticlesQuery,
  GetMarketingBannersQuery,
  GetPageByRouteQuery,
} from "@eurodrive/apollo"
import { Articles, Banner, FormBlock, Marketing } from "@eurodrive/ui"
import { extractProperty, getBreadCrumbs } from "@eurodrive/utils"
import { LeasingCarDto, SaleCarDto, SearchMetadataResponse } from "api"
import Categories from "./Categories"
import Intro from "./Intro"
import PopularCars from "./PopularCars"

type Props = {
  data: GetPageByRouteQuery
  locale: string
  articles: GetArticlesQuery
  marketing: GetMarketingBannersQuery
  cars: (SaleCarDto | LeasingCarDto)[]
  metadata: SearchMetadataResponse
  contactForm: GetPageByRouteQuery
  manufacturerCode: number
}

export default function BannerPage({
  data,
  locale,
  articles,
  marketing,
  cars,
  metadata,
  contactForm,
  manufacturerCode,
}: Props) {
  const object = data.page
  const categoryChildren =
    object?.children?.map((child: any) => ({
      name: child?.name || "",
      classification: extractProperty(child, "classification"),
      image: extractProperty(child, "image"),
    })) || []

  const brandName = extractProperty(object, "brandName")
  const brandIcon = extractProperty(object, "brandIcon")
  const media = extractProperty(object, "media")
  const heroBanner = extractProperty(object, "heroBanner")
  const textToRight = extractProperty(object, "textToRight")
  const popularCars = extractProperty(object, "popularCars")
  const popularCarsTitle = extractProperty(popularCars?.[0], "title")
  const popularCarsButtonTitle = extractProperty(popularCars?.[0], "buttonText")
  const marketingBanner = extractProperty(object, "marketingBanner")
  const leadForm = extractProperty(object, "leadForm")
  const articlesObject = extractProperty(object, "articles")
  const breadCrumbs = getBreadCrumbs(data, locale)
  return (
    <>
      <Banner
        data={heroBanner?.[0]}
        height="600px"
        breadCrumbs={{
          parents: [...breadCrumbs.parents],
          selfObject: { title: `מותג ${brandName}`, url: "" },
        }}
      />
      <Intro textToRight={textToRight?.[0]} />
      <Categories
        categoryChildren={categoryChildren}
        manufacturerCode={manufacturerCode}
      />
      <PopularCars
        metadata={metadata}
        cars={cars}
        title={popularCarsTitle}
        buttonText={popularCarsButtonTitle}
        brandIcon={brandIcon}
        manufacturerCode={manufacturerCode}
      />
      <Marketing marketing={marketing} data={marketingBanner} />
      <FormBlock contactForm={contactForm} />
      <Articles
        data={articlesObject?.[0]}
        articles={articles}
        noBackgroundColor
      />
    </>
  )
}
